{
    "404": "¡Oh, no! ¡Hemos buscado por el mar y no encontramos tu página!"
}
